import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { SUPPORTED_EMAIL_EVENTS } from "../notification";

type AddEmailNotification = {
    readonly emailAddress: string;
    readonly onEvent: SUPPORTED_EMAIL_EVENTS[];
};

type AddNotificationCommand = {
    readonly _id: string;
    readonly _type: "ADD_NOTIFICATION_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly ownerId: ProviderId;
    readonly data: AddEmailNotification;
};

type FactoryParams = Except<
    AddNotificationCommand,
    "_id" | "_type" | "_createdAt"
>;
const addNotificationCommandFactory = (params: FactoryParams) => {
    const AddNotificationCommand: AddNotificationCommand = {
        ...params,
        _id: generateId({ prefix: "add_notification_command__" }),
        _type: "ADD_NOTIFICATION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return AddNotificationCommand;
};

const addNotificationCommandZodSchema: z.ZodSchema<AddNotificationCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("ADD_NOTIFICATION_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        ownerId: providerIdZodSchema,
        data: z.object({
            emailAddress: z.string().email(),
            onEvent: z.array(
                z.union([z.literal("SETTLEMENT_NOTE"), z.literal("NEW_ORDER")]),
            ),
        }),
    });

export { addNotificationCommandFactory, addNotificationCommandZodSchema };
export type {
    AddNotificationCommand,
    FactoryParams as CreateAddNotificationCommandParams,
};
